<template>
  <v-container fluid white>
    <div class="licitacao-esclarecimento">
      <div class="text-info-vazio container-box justify-center">
        <img class="mt-5" src="img/icons/box_archive.svg" alt="Vazio" />
        <p class="text-info">Você não possui <b>contratações</b> <br/></p>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'CredenciamentoExecucaoFornecedorVazio',
  components: {},
  data(){
    return {
      credenciamentoId: this.$route.params.id,
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="stylus">
.text-info
  color #777 !important
  font-size 18px
  text-align center

.text-info-vazio
  display flex
  flex-direction row
  justify-content center
  align-items center

.container-box
  margin-top 20px
  width 100%
  height 300px
  border 1px solid #CCCCCC
  border-radius 5px
  display flex
  flex-direction column

.licitacao-esclarecimento
  min-height 59vh
</style>